module.exports = __webpack_public_path__ + "img/loading.a4b42243.d90413ed.gif";